import type { ReactNode } from 'react';

import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';

import type { FeatureFlag } from 'hooks/useFeatureSwitch/useIsFeatureOn';

export enum MenuOptions {
  FUNCTIONS = 'functions',
  HANDOFF = 'handoff',
  SMS = 'sms',
  FLOWS = 'flows',
  STEPS = 'steps',
  VARIANT_ATTRIBUTES = 'variant_attributes',
  TRANSITION_FUNCTION = 'transition_function',
  ENTITIES = 'entities',
  VARIABLES = 'variables',
  INTEGRATIONS = 'integrations',
  TRANSLATIONS = 'translations',
}

export enum SetupOptions {
  STEPS = 'steps_setup',
  EXIT_FLOW = 'exit_flow_setup',
}

export type ActionPickerConfig = {
  [K in MenuOptions]?: {
    select: boolean;
    create: boolean;
  };
};

export class PickerOption extends MenuOption {
  name: string;
  keywords: string[];
  icon?: ReactNode;
  description?: string;
  type: 'option' | 'action';
  index: number;
  prefix: string;
  id: string;
  menuOption: MenuOptions;

  setup?: SetupOptions;
  transform?: (option: PickerOption) => { id: string; prefix?: string };

  constructor({
    name,
    id,
    prefix,
    menuOption,
    description,
    icon,
    options,
    transform,
  }: {
    name: string;
    id: string;
    prefix: string;
    menuOption: MenuOptions;
    description?: string;
    icon?: ReactNode;
    options: {
      keywords?: string[];
      type?: 'option' | 'action';
      index: number;
      setup?: SetupOptions;
    };
    transform?: (option: PickerOption) => { id: string; prefix?: string };
  }) {
    super(name);

    this.setup = options.setup;
    this.name = name;
    this.id = id;
    this.prefix = prefix;
    this.menuOption = menuOption;
    this.keywords = options.keywords ?? [];
    this.index = options.index;
    this.type = options.type ?? 'option';
    this.description = description;
    this.icon = icon;
    this.transform = transform;
  }
}

export interface OptionGroup {
  name: string;
  groupId: MenuOptions;
  singularName: string;
  icon?: ReactNode;
  options?: PickerOption[];
  actions?: PickerOption[];
  featureFlag?: FeatureFlag;
}
